import { Component, effect, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ThemeService } from '@core/services/theme.service';
import { ToastDrawerComponent } from 'ngx-mt-ui-lib/components/toast/toast-drawer';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastDrawerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly router = inject(Router);
  private readonly themeService = inject(ThemeService);

  private readonly darkThemeOn = [
    'page-not-found',
    'no-access',
    'security-administrator',
  ];

  private readonly navigationEnd = toSignal<NavigationEnd>(
    this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
    ) as Observable<NavigationEnd>,
  );

  constructor() {
    effect(() => {
      const _ = this.navigationEnd();
      const url = this.router.url;

      const isDarkTheme = this.darkThemeOn.some((path) => url.includes(path));

      if (isDarkTheme) {
        this.themeService.setDarkTheme();
      } else {
        this.themeService.setUserTheme();
      }
    });
  }
}
